<!-- 落地页用户 -->
<template>
<div>
	<!-- id="put-account" -->
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<a-tabs :activeKey="tab_key" type="card" @change="callback" :tabBarGutter="7">
			<a-tab-pane v-for="(item,index) in showTabData" :key="item.keys" :tab="item.name"></a-tab-pane>
		</a-tabs>
	</div>
	</div>	
		
	<div style="padding: 0 0 30px 0;">
		<router-view/>
	</div>
</div>
</template>

<script>
export default {
	name: 'landPageUser_',
	data() {
		return {
			tab_key: "1",
			body_width: 1600,
			table_scroll_width: 1600,
			
			tabData: [
				{name:"自建落地页用户", keys: "1", urls:"/LPzj", },
				{name:"基木鱼用户", keys: "2", urls:"/LPjmy", },
				{name:"巨量点击用户", keys: "3", urls:"/LPjl", },
				{name:"OPPO点击监测用户", keys: "6", urls:"/clickOPPO", },
				{name:"VIVO点击监测用户", keys: "7", urls:"/clickVIVO", },
				{name:"华为点击监测用户", keys: "8", urls:"/clickHUAWEI", },
				{name:"微博点击监测用户", keys: "9", urls:"/clickWeibo", },
				{name:"百度点击用户", keys: "10", urls:"/clickBD", },
				{name:"腾讯ADQ点击用户", keys: "11", urls:"/clickTxADQ", },
				{name:"360落地页用户", keys: "5", urls:"/LP360", },
				{name:"快手落地页用户", keys: "12", urls:"/LPks", },
				{name:"星图点击用户", keys: "13", urls:"/clickXT", },
				{name:"B站点击用户", keys: "14", urls:"/clickBilibili", },
			],
			showTabData: [{name:"",}],
		}
	},
	mounted(){
		let that = this
		
		
		// console.log("路由地址",this.$route.fullPath);
		let page_path = this.$route.fullPath
		let tab_path = []
		
		let n_data = JSON.parse(localStorage.getItem("get_navData"))
		// 找出当前路径所在的vues数据。
		n_data.forEach((res,index)=>{
			if(res.child.length != 0){
				res.child.forEach((res_a,index_a)=>{
					if(res_a.child.length != 0){
						res_a.child.forEach((res_c,index_c)=>{
							res_c.vues.forEach((res_e,index_e)=>{
								if(res_e.vue_url == page_path){
									tab_path = res_c.vues
								}
							})
							
						})
					}
				})
				
			}
		})
		
		let tt_data = []
		// 根据后端配置的顺序进行排序
		console.log(tab_path,`tab_path`)
		tab_path.forEach((res,index)=>{
			that.tabData.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					tt_data.push(res_z)
				}
			})
		})
		that.showTabData = tt_data
		

		
		function checkTab(urls){
			if(urls.indexOf("LPzj") > -1){ // 自建落地页用户
				that.tab_key = "1"
			}
			else if(urls.indexOf("LPjmy") > -1){ // 基木鱼用户
				that.tab_key = "2"
			}
			else if(urls.indexOf("LPjl") > -1){ // 巨量点击用户
				that.tab_key = "3"
			}
			else if(urls.indexOf("LP360") > -1){ // 360落地页用户
				that.tab_key = "5"
			}
			else if(urls.indexOf("clickOPPO") > -1){ // OPPO点击监测用户
				that.tab_key = "6"
			}
			else if(urls.indexOf("clickVIVO") > -1){ // VIVO点击监测用户
				that.tab_key = "7"
			}
			else if(urls.indexOf("clickHUAWEI") > -1){ //华为点击监测用户
				that.tab_key = "8"
			}
			else if(urls.indexOf("clickWeibo") > -1){ //微博点击监测用户
				that.tab_key = "9"
			}
			else if(urls.indexOf("clickBD") > -1){ //百度点击用户
				that.tab_key = "10"
			}
			else if(urls.indexOf("clickTxADQ") > -1){ //腾讯ADQ点击用户
				that.tab_key = "11"
			}
			else if(urls.indexOf("LPks") > -1){ //快手落地页用户
				that.tab_key = "12"
			}
			else if(urls.indexOf("clickXT") > -1){
				that.tab_key = "13"
			}
			else if(urls.indexOf("clickBilibili") > -1){
				that.tab_key = "14"
			}
		}
		// 保证页面刷新能更新tab选中状态
		checkTab(that.$route.fullPath)
		
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		// 接收粘性定位用的参数
		this.$bus.$on('stickyData',(e)=>{
		    // console.log('landPageUser',e)
			that.table_scroll_width = e
		})
		
		// 接收子页面传过来的路径
		this.$bus.$on('tabPath',(e)=>{
		    console.log('landPageUser-tabPath-----',e)
			// that.table_scroll_width = e
			checkTab(e)
		})
	},
	// 销毁生命周期
	beforeDestroy(){
	    this.$bus.$off('stickyData') // 销毁，减轻vue压力
		// 如果不销毁，后面可能会重复执行多次，因为没有销毁，所以触发的会一直在
		this.$bus.$off('tabPath') // 销毁，减轻vue压力
	},
	methods:{
		// 切换tab
		callback(e){
			console.log(e);
			if(e == "1"){ // 自建落地页用户
				this.tab_key = "1"
				this.$router.push({path: '/LPzj'})
			}
			else if(e == "2"){ // 基木鱼用户
				this.tab_key = "2"
				this.$router.push({path: '/LPjmy'})
			}
			else if(e == "3"){ // 巨量点击用户
				this.tab_key = "3"
				this.$router.push({path: '/LPjl'})
			}
			else if(e == "5"){ // 360落地页用户
				this.tab_key = "5"
				this.$router.push({path: '/LP360'})
			}
			else if(e == "6"){ // OPPO点击监测用户
				this.tab_key = "6"
				this.$router.push({path: '/clickOPPO'})
			}
			else if(e == "7"){ // VIVO点击监测用户
				this.tab_key = "7"
				this.$router.push({path: '/clickVIVO'})
			}
			else if(e == "8"){ // 华为点击监测用户
				this.tab_key = "8"
				this.$router.push({path: '/clickHUAWEI'})
			}
			else if(e == "9"){ // 微博点击监测用户
				this.tab_key = "9"
				this.$router.push({path: '/clickWeibo'})
			}
			else if(e == "10"){ // 百度点击用户
				this.tab_key = "10"
				this.$router.push({path: '/clickBD'})
			}
			else if(e == "11"){ // 腾讯ADQ点击用户
				this.tab_key = "11"
				this.$router.push({path: '/clickTxADQ'})
			}
			else if(e == "12"){ // 快手落地页用户
				this.tab_key = "12"
				this.$router.push({path: '/LPks'})
			}
			else if(e == "13"){
				this.tab_key = "13"
				this.$router.push({path: '/clickXT'})
			}
			else if(e == "14"){
				this.tab_key = "14"
				this.$router.push({path: '/clickBilibili'})
			}
		}
	}
}
</script>

<style>
</style>